import React from 'react'
import { getLabel, ScorecardLabelLevel } from '../../../../../common/clientProfile'
import { ScorecardResult, Scorecard as ScorecardModel } from '../../../../../models/Scorecard'
import { Accordion, Col, Row } from 'react-bootstrap'
import { ScorecardProperty } from './ScorecardProperty'

export type ScorecardSectionProps = {
  vkey: string
  value: any
  scorecard: ScorecardModel
  scorecardResult: ScorecardResult
}

export const ScorecardSection: React.FC<ScorecardSectionProps> = ({ vkey, value, scorecard, scorecardResult }) => {
  if (typeof value !== 'object' || value === null) {
    const label = getLabel(scorecard.descriptor, vkey, value, ScorecardLabelLevel.SECTION, scorecard.metadata)
    return (
      <div key={vkey}>
        <ScorecardProperty rootKeyName='' keyName={vkey} scorecard={scorecard} scorecardResult={scorecardResult} />
      </div>
    )
  }

  return (
    <div key={vkey}>
      {!Array.isArray(value) ? (
        <ScorecardObjectItem vkey={vkey} value={value} scorecard={scorecard} scorecardResult={scorecardResult} />
      ) : (
        <ScorecardListObjectItem vkey={vkey} values={value} scorecard={scorecard} scorecardResult={scorecardResult} />
      )}
    </div>
  )
}

interface ScorecardObjectItemProps {
  vkey: string
  value: { [key: string]: any }
  scorecard: ScorecardModel
  scorecardResult: ScorecardResult
  idx?: number
}

const ScorecardObjectItem: React.FC<ScorecardObjectItemProps> = ({ vkey, value, scorecard, scorecardResult, idx }) => {
  const fullKey = `${vkey}${idx !== undefined ? `[${idx}]` : ''}`

  const isNested = (obj: any) => {
    if (typeof obj !== 'object' || obj === null) {
      return false
    }

    for (const key in obj) {
      if (obj.hasOwnProperty(key) && typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
        return true
      }
    }
    return false
  }

  const renderObject = (nestedKey?: string) => {
    const rootKey = nestedKey ? `${fullKey}.${nestedKey}` : fullKey
    const newValue = nestedKey ? value[nestedKey] : value
    const label = getLabel(scorecard.descriptor, rootKey, value, ScorecardLabelLevel.SECTION, scorecard.metadata)
    return (
      <Row>
        <Col>
          <Accordion>
            <Accordion.Item eventKey={fullKey} className='mt-3'>
              <Accordion.Header className='custom-accordion-header'>
                <span className='scorecard-item-header'>{label}</span>
              </Accordion.Header>
              <Accordion.Body className='p-0'>
                {Object.keys(newValue).map((key) => {
                  return (
                    <ScorecardProperty
                      key={`section.${rootKey}.${key}`}
                      rootKeyName={rootKey}
                      keyName={key}
                      scorecard={scorecard}
                      scorecardResult={scorecardResult}
                    />
                  )
                })}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
    )
  }

  const renderNestedObject = () => {
    return (
      <>
        {Object.keys(value).map((key) => {
          return renderObject(key)
        })}
      </>
    )
  }

  return <div>{isNested(value) ? renderNestedObject() : renderObject()}</div>
}

interface ScorecardListItemProps {
  vkey: string
  values: object[]
  scorecard: ScorecardModel
  scorecardResult: ScorecardResult
}

const ScorecardListObjectItem: React.FC<ScorecardListItemProps> = ({ vkey, values, scorecard, scorecardResult }) => {
  return (
    <div>
      {values.map((value, index) => {
        return <ScorecardObjectItem key={`${vkey}[${index}]`} vkey={vkey} idx={index} value={value} scorecard={scorecard} scorecardResult={scorecardResult} />
      })}
    </div>
  )
}
